module.exports = __webpack_public_path__ + "img/bixiu06.49213f21.png";